import styled from 'styled-components'

export const Style = styled.div`
  .column-margin {
    margin-bottom: 24px;
    margin-top: 110px;
  }
  .bottom-margin {
    margin-bottom: 20px;
  }
  .page-line {
    text-align: center;

    div {
      background: linear-gradient(270deg, #ffd192 0%, #ff8e30 100%);
      width: 70px;
      height: 8px;
      border-radius: 8px;
      display: inline-block;
    }
  }

  @media screen and (min-width: 300px) and (max-width: 768px) {
    background: linear-gradient(to bottom, rgba(243, 203, 138, 0), #f3cc8a);
  }
`
